import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Edit.module.css'
import Pen from "../../../../assets/Icon/Pen";

const Edit = ({ marineService, defaultMarine }) => {
    const marineResetData = {
        id: 0,
        name: "",
        mobile: "",
        address: "",
        address2: "",
        code: "",
        country: "",
        district: "",
        city: "",
        logo: "",

    }

    const initEditMarine = (marine) => {
        return {
            id: marine.id,
            name: marine.name,
            mobile: marine.mobile,
            address: marine.address,
            address2: marine.address2,
            code: marine.code,
            country: marine.country,
            district: marine.district,
            city: marine.city,
            logo: marine.logo,
        }
    }

    const [newMarine, setNewMarine] = useState(marineResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validateMarine = (marine) => {
        const messages = {};
    
        if (marine.name.length < 2) {
            messages.name = { message: 'მიუთითეთ სახელი', isValid: false };
        }
     
 
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {
        const isValidate = validateMarine(newMarine)
        
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateMarine(newMarine)
        }
      }, [newMarine, isFirstValidated]);

      useEffect(() => {
        const editedCar = initEditMarine(defaultMarine)
        setNewMarine(editedCar)
    }, [defaultMarine]);

    const [isModalOpen, setIsModalOpen] = useState(false);
 
    const saveHandle = () => {
         
        const isValidate = validateMarine(newMarine)

        if (isValidate === true) {
            marineService.update(newMarine)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true) 
        } 
        
    };

    const handleMarineChange = async (event) => {
        let val = event.target.value;
        setNewMarine(prevMarine => ({
            ...prevMarine,
            [event.target.name]: val
        })); 
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false) 
    }

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }
 
  
    const handleMarineInt = async (event) => {
        let val = event.target.value;
        
        setNewMarine(prevMarine => ({
            ...prevMarine,
            [event.target.name]: convertToInt(val)
        })); 
    };


    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; // Regular expression to match only numeric characters

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };
  
    return (
        <div>

            <span className={ cl.editBtn } onClick={() => openAdd()} >
                <Pen/> განახლება
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <Pen /></span> განახლება
                    </h3>
                </div>

                <div className={cl.groupInput}> 
                    <label>დასახელება</label>
                    <input type="textS" className={validates && validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                        placeholder="დასახელება" 
                        name="name" 
                        value={newMarine.name} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>მობილური</label>
                    <input type="textS" className={validates && validates.mobile ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="mobile" 
                        value={newMarine.mobile} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>მისამართი</label>
                    <input type="textS" className={validates && validates.address ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="address" 
                        value={newMarine.address} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>მისამართი 2</label>
                    <input type="textS" className={validates && validates.address2 ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="address2" 
                        value={newMarine.address2} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>ინდექს კოდი</label>
                    <input type="textS" className={validates && validates.code ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="code" 
                        value={newMarine.code} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}> 
                    <label>ქვეყანა</label>
                    <input type="textS" className={validates && validates.country ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="country" 
                        value={newMarine.country} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>
  
                <div className={cl.groupInput}> 
                    <label>რეგიონი</label>
                    <input type="textS" className={validates && validates.district ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="district" 
                        value={newMarine.district} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>
  
                <div className={cl.groupInput}> 
                    <label>ქალაქი</label>
                    <input type="textS" className={validates && validates.city ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="city" 
                        value={newMarine.city} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>


                <div className={cl.groupInput}> 
                    <label>Logo</label>
                    <input type="textS" className={validates && validates.logo ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="logo" 
                        value={newMarine.logo} 
                        onChange={handleMarineChange} 
                        autoComplete="off" />
                </div>
 
 
                <span onClick={saveHandle} className={cl.btnPrimary}>შენახვა</span>

            </Modal>
        </div>
    );
};

export default Edit;